import { ReactNode } from 'react';

import { Colors } from '@sternum/web/components/theme/constants';
import { SternumLogoWithTextIcon } from '@sternum/web/icons';

import { BottomLines, CenterLines, TopLines } from './AbstractLines.component';

import {
  BottomLinesWrapper,
  CenterLinesWrapper,
  Container,
  Content,
  LogoBox,
  TopLinesWrapper,
} from './AuthPromptContainer.styles';

interface AuthConfirmationContainer {
  children: ReactNode;
}

export function AuthPromptContainer({ children }: AuthConfirmationContainer) {
  return (
    <Container>
      <LogoBox>
        <SternumLogoWithTextIcon color={Colors.BrandBlueLightest} />
      </LogoBox>

      <Content>{children}</Content>

      <TopLinesWrapper>
        <TopLines preserveAspectRatio="xMinYMin meet" />
      </TopLinesWrapper>

      <CenterLinesWrapper>
        <CenterLines preserveAspectRatio="xMinYMin meet" />
      </CenterLinesWrapper>

      <BottomLinesWrapper>
        <BottomLines preserveAspectRatio="xMinYMin meet" />
      </BottomLinesWrapper>
    </Container>
  );
}
